import React, { useRef, useState, useEffect } from 'react';
import domtoimage from 'dom-to-image-more';
import { Download, Printer, X, User } from 'lucide-react';
import { QRCodeCanvas } from 'qrcode.react';
import { Button } from '../components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

// Separate component for the actual poster content (reused in preview + hidden capture div)
const PosterContent = ({ caseData, b64, bg, lbg, gm, rows, caseUrl, loading }) => {
  const isMissing = caseData.case_type === 'missing';
  const pUrl = (p) => p ? (p.startsWith('http') ? p : `${API}/api/files/${p}`) : null;
  const tl = { padding: '5px 10px', fontSize: '12px', fontWeight: '600', color: '#6b7280', borderBottom: '1px solid #f3f4f6', width: '32%' };
  const tv = { padding: '5px 10px', fontSize: '13px', fontWeight: '700', color: '#111', borderBottom: '1px solid #f3f4f6' };

  return (
    <>
      <div style={{ background: bg, color: '#fff', padding: '16px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: '28px', fontWeight: '900', whiteSpace: 'nowrap' }}>{isMissing ? 'लापता व्यक्ति' : 'अज्ञात व्यक्ति'}</div>
          <div style={{ fontSize: '10px', opacity: 0.85, letterSpacing: '2px', whiteSpace: 'nowrap' }}>{isMissing ? 'MISSING PERSON' : 'UNKNOWN PERSON'}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '8px', opacity: 0.7, whiteSpace: 'nowrap' }}>केस नंबर</div>
          <div style={{ fontSize: '13px', fontWeight: '700', whiteSpace: 'nowrap' }}>{caseData.case_id}</div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '14px', padding: '14px 18px 10px' }}>
        <div style={{ width: '160px', height: '190px', border: `3px solid ${bg}`, overflow: 'hidden', background: '#f5f5f5', flexShrink: 0 }}>
          {loading ? <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#999' }}>...</div>
          : (b64 || caseData.photo_url) ? <img src={b64 || pUrl(caseData.photo_url)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><User style={{ width: '40px', height: '40px', color: '#d1d5db' }} /></div>}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: '22px', fontWeight: '900', color: '#111', lineHeight: 1.15, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{caseData.name || 'अज्ञात'}</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px' }}>
            {caseData.age && <span style={{ background: lbg, border: `1px solid ${bg}44`, padding: '2px 8px', borderRadius: '12px', fontSize: '10px', fontWeight: '700', whiteSpace: 'nowrap' }}>{caseData.age} वर्ष</span>}
            <span style={{ background: lbg, border: `1px solid ${bg}44`, padding: '2px 8px', borderRadius: '12px', fontSize: '10px', fontWeight: '700', whiteSpace: 'nowrap' }}>{gm[caseData.gender] || caseData.gender}</span>
            {caseData.height && <span style={{ background: lbg, border: `1px solid ${bg}44`, padding: '2px 8px', borderRadius: '12px', fontSize: '10px', fontWeight: '700', whiteSpace: 'nowrap' }}>{caseData.height}</span>}
          </div>
          {caseData.identifying_marks && <div style={{ marginTop: '8px', padding: '6px 8px', background: '#FEF3C7', border: '1px solid #FDE68A', borderRadius: '5px' }}><div style={{ fontSize: '9px', fontWeight: '800', color: '#92400E' }}>पहचान चिह्न</div><div style={{ fontSize: '12px', color: '#78350F', fontWeight: '700', marginTop: '1px' }}>{caseData.identifying_marks}</div></div>}
          {caseData.clothing && <div style={{ marginTop: '5px', padding: '6px 8px', background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: '5px' }}><div style={{ fontSize: '9px', fontWeight: '800', color: '#1E40AF' }}>पहनावा</div><div style={{ fontSize: '12px', color: '#1E3A5F', marginTop: '1px' }}>{caseData.clothing}</div></div>}
        </div>
      </div>

      <div style={{ padding: '0 18px 6px' }}>
        <div style={{ fontSize: '11px', fontWeight: '800', color: bg, borderBottom: `2px solid ${bg}`, paddingBottom: '3px', marginBottom: '2px', whiteSpace: 'nowrap' }}>विवरण / DETAILS</div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}><tbody>{rows.map((r, i) => <tr key={i}><td style={tl}>{r[0]}</td><td style={tv}>{r[1]}</td></tr>)}</tbody></table>
      </div>

      {(caseData.reporter_name || caseData.reporter_mobile) && (
        <div style={{ padding: '4px 18px 6px' }}>
          <div style={{ fontSize: '11px', fontWeight: '800', color: bg, borderBottom: `2px solid ${bg}`, paddingBottom: '3px', marginBottom: '2px', whiteSpace: 'nowrap' }}>रिपोर्टर / REPORTER</div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}><tbody>
            {caseData.reporter_name && <tr><td style={tl}>नाम</td><td style={tv}>{caseData.reporter_name}</td></tr>}
            {caseData.reporter_mobile && <tr><td style={tl}>मोबाइल</td><td style={tv}>{caseData.reporter_mobile}</td></tr>}
            {caseData.reporter_relation && <tr><td style={tl}>संबंध</td><td style={tv}>{caseData.reporter_relation}</td></tr>}
          </tbody></table>
        </div>
      )}

      <div style={{ background: bg, color: '#fff', padding: '14px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '10px' }}>
        <div>
          <div style={{ fontSize: '10px', opacity: 0.85, whiteSpace: 'nowrap' }}>यदि जानकारी हो तो तुरंत संपर्क करें</div>
          <div style={{ fontSize: '26px', fontWeight: '900', letterSpacing: '1px', whiteSpace: 'nowrap' }}>{caseData.reporter_mobile}</div>
          <div style={{ fontSize: '11px', opacity: 0.9, whiteSpace: 'nowrap' }}>{caseData.reporter_name}{caseData.reporter_relation && ` (${caseData.reporter_relation})`}</div>
        </div>
        <div style={{ background: '#fff', padding: '5px', borderRadius: '5px', lineHeight: 0 }}>
          <QRCodeCanvas value={caseUrl} size={70} level="M" />
        </div>
      </div>

      <div style={{ background: '#111', color: '#9ca3af', padding: '6px 18px', display: 'flex', justifyContent: 'space-between', fontSize: '9px' }}>
        <div style={{ whiteSpace: 'nowrap' }}><span style={{ color: '#fff', fontWeight: '700' }}>गुमसुदा</span> | gumsuda.com | {caseData.case_id}</div>
        <div style={{ whiteSpace: 'nowrap' }}>QR स्कैन करें</div>
      </div>
    </>
  );
};

const PrintPoster = ({ caseData, onClose }) => {
  const captureRef = useRef(null);
  const isMissing = caseData.case_type === 'missing';
  const bg = isMissing ? '#DC2626' : '#D97706';
  const lbg = isMissing ? '#FEF2F2' : '#FFFBEB';
  const gm = { male: 'पुरुष', female: 'महिला', other: 'अन्य' };
  const caseUrl = `${window.location.origin}/case/${caseData.case_id}`;
  const [b64, setB64] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dling, setDling] = useState(false);

  const pUrl = (p) => p ? (p.startsWith('http') ? p : `${API}/api/files/${p}`) : null;

  useEffect(() => {
    (async () => {
      const url = pUrl(caseData.photo_url);
      if (!url) { setLoading(false); return; }
      try {
        const r = await fetch(url); const bl = await r.blob();
        const rd = new FileReader(); rd.onloadend = () => { setB64(rd.result); setLoading(false); }; rd.readAsDataURL(bl);
      } catch { setLoading(false); }
    })();
  }, [caseData.photo_url]);

  const doCapture = async () => {
    const el = captureRef.current;
    if (!el) return null;
    await new Promise(r => setTimeout(r, 500));
    // Step 1: Capture at native DOM size (no transforms = no layout shift)
    const nativeUrl = await domtoimage.toPng(el, {
      quality: 1,
      bgcolor: '#ffffff',
      cacheBust: true,
      width: el.offsetWidth,
      height: el.offsetHeight,
    });
    // Step 2: Upscale 2x on canvas for A4 print quality
    const img = new Image();
    img.src = nativeUrl;
    await new Promise((res, rej) => { img.onload = res; img.onerror = rej; });
    const canvas = document.createElement('canvas');
    canvas.width = img.width * 2;
    canvas.height = img.height * 2;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/png');
  };

  const downloadPNG = async () => {
    if (dling) return;
    setDling(true);
    try {
      const dataUrl = await doCapture();
      if (!dataUrl) return;
      const link = document.createElement('a');
      link.download = `${caseData.name || 'poster'}-${caseData.case_id}.png`;
      link.href = dataUrl;
      link.click();
    } catch (e) { console.error(e); }
    finally { setDling(false); }
  };

  const doPrint = async () => {
    try {
      const dataUrl = await doCapture();
      if (!dataUrl) return;
      const pw = window.open('', '_blank');
      pw.document.write(`<!DOCTYPE html><html><head><title>${caseData.name}</title>
<style>*{margin:0;padding:0;-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}
@page{size:A4 portrait;margin:0}body{margin:0}img{width:100%;height:auto;display:block}</style>
</head><body><img src="${dataUrl}" />
<script>window.onload=function(){setTimeout(function(){window.print();window.onafterprint=function(){window.close()}},500)}<\/script>
</body></html>`);
      pw.document.close();
    } catch (e) { console.error(e); }
  };

  const rows = [];
  if (caseData.age) rows.push(['उम्र', `${caseData.age} वर्ष`]);
  if (caseData.gender) rows.push(['लिंग', gm[caseData.gender] || caseData.gender]);
  if (caseData.height) rows.push(['ऊंचाई', caseData.height]);
  if (caseData.complexion) rows.push(['रंग', caseData.complexion]);
  if (caseData.identifying_marks) rows.push(['पहचान चिह्न', caseData.identifying_marks]);
  if (caseData.clothing) rows.push(['पहनावा', caseData.clothing]);
  const loc = caseData.last_seen_location || caseData.found_location;
  if (loc) rows.push([isMissing ? 'अंतिम स्थान' : 'पाया गया', loc]);
  const dt = caseData.last_seen_date || caseData.found_date;
  if (dt) rows.push(['तारीख', dt]);
  if (caseData.city) rows.push(['शहर/राज्य', `${caseData.city}, ${caseData.state}`]);
  if (caseData.police_station) rows.push(['थाना', caseData.police_station]);

  const sc = Math.min(window.innerWidth < 500 ? (window.innerWidth - 40) / 595 : 420 / 595, 1);
  const props = { caseData, b64, bg, lbg, gm, rows, caseUrl, loading };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-start justify-center overflow-y-auto" onClick={onClose} data-testid="poster-modal">
      <div className="w-full max-w-lg mx-auto my-4 bg-white rounded-2xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 z-10 bg-white border-b px-4 py-3 flex items-center justify-between">
          <h3 className="font-outfit font-bold text-lg">A4 पोस्टर</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full"><X className="w-5 h-5" /></button>
        </div>
        <div className="px-4 py-3 flex gap-2 border-b">
          <Button onClick={downloadPNG} disabled={dling || loading} className="flex-1 bg-black hover:bg-gray-800 rounded-xl h-11 text-sm" data-testid="download-poster-png-btn">
            <Download className="w-4 h-4 mr-2" />{dling ? 'डाउनलोड हो रहा...' : 'डाउनलोड PNG'}
          </Button>
          <Button onClick={doPrint} variant="outline" className="flex-1 rounded-xl h-11 text-sm" data-testid="print-poster-btn">
            <Printer className="w-4 h-4 mr-2" />प्रिंट A4
          </Button>
        </div>

        {/* PREVIEW (scaled for modal) */}
        <div className="px-3 py-4 bg-gray-100 overflow-auto flex justify-center">
          <div style={{ width: `${595 * sc}px`, overflow: 'hidden' }}>
            <div style={{ width: '595px', background: '#fff', fontFamily: "'Outfit', sans-serif", border: `3px solid ${bg}`, transform: `scale(${sc})`, transformOrigin: 'top left' }}>
              <PosterContent {...props} />
            </div>
          </div>
        </div>

        {/* HIDDEN CAPTURE DIV (full 595px, no transform) */}
        <div style={{ position: 'fixed', left: '-9999px', top: 0 }}>
          <div ref={captureRef} style={{ width: '595px', background: '#fff', fontFamily: "'Outfit', sans-serif", border: `3px solid ${bg}` }}>
            <PosterContent {...props} />
          </div>
        </div>

        <div className="p-3 border-t">
          <div className="flex gap-2">
            <button onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(`${isMissing ? 'लापता' : 'अज्ञात'}: ${caseData.name}, ${caseData.age} वर्ष\nसंपर्क: ${caseData.reporter_mobile}\n\n${window.location.origin}/api/share/${caseData.case_id}`)}`, '_blank')} className="flex-1 py-2.5 bg-green-500 text-white text-sm font-medium rounded-xl text-center hover:bg-green-600">WhatsApp</button>
            <button onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${window.location.origin}/api/share/${caseData.case_id}`)}`, '_blank')} className="flex-1 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-xl text-center hover:bg-blue-700">Facebook</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintPoster;
